module.exports = __webpack_public_path__ + "img/HuayunHechuang.664fe857.jpg";